import { settingsApi } from './settingsApi';
export { settingsApi };
export default settingsApi;